type Props = {
  children?: React.ReactNode;
};

export function TimelineLine({ children }: Props) {
  return (
    <div className="relative h-full border-x border-stroke-neutral-soft">
      {children}
    </div>
  );
}
